import { useTranslation } from "react-i18next";
import CounterControls from "./counter";
import PromCd from "./promCd";
import Tooltip from "components/tooltip";
import { useBookInfContext } from "components/context/bookInfContext";
import { useAuthContext } from "components/context/authContext";
import { useEffect } from "react";
import "./roominf.scss";

export default function RoomInfWeb() {
  const { t } = useTranslation();
  const { lodInf } = useAuthContext();
  const { bookInf, onBookInf } = useBookInfContext();

  useEffect(() => {
    if (lodInf) {
      onBookInf({
        rmCnt: lodInf.defRmCt ?? 1,
        adltCnt: lodInf.defAdltPerCt ?? 1,
      });
    }
  }, [lodInf]);

  return (
    <div className="room-inf-web mt-[1rem]">
      <div className="w-[183px]">
        <h5>{t("bck_ttl_hm_rm_cnt")}</h5>
        <CounterControls
          count={bookInf?.rmCnt}
          handleDecrease={() => {
            if (bookInf?.rmCnt === 1) {
              return;
            }
            onBookInf({
              rmCnt: bookInf?.rmCnt - 1,
            });
          }}
          handleIncrease={() => {
            onBookInf({
              rmCnt: bookInf?.rmCnt + 1,
            });
          }}
        />
      </div>
      <div className="flex gap-[25px] flex-1">
        <div>
          <h5>{t("bck_ttl_hm_adl")}</h5>
          <CounterControls
            count={bookInf?.adltCnt}
            handleDecrease={() => {
              if (bookInf?.adltCnt === 1) {
                return;
              }
              onBookInf({
                adltCnt: bookInf?.adltCnt - 1,
              });
            }}
            handleIncrease={() => {
              onBookInf({
                adltCnt: bookInf?.adltCnt + 1,
              });
            }}
          />
        </div>
        <div className="">
          <h5>
            <span>{t("bck_ttl_hm_chl")}</span>
            <Tooltip
              text={
                t("bck_ttl_hm_chl") +
                " " +
                lodInf?.babyAgeStndV +
                " " +
                "~" +
                " " +
                lodInf?.chldAgeStndV +
                t("bck_ttl_hm_old")
              }
            />
          </h5>

          <CounterControls
            count={bookInf?.childCnt ?? 0}
            disabled={(bookInf?.childCnt ?? 0) === 0}
            handleDecrease={() => {
              if (bookInf?.childCnt === 0) {
                return;
              }
              onBookInf({
                childCnt: bookInf?.childCnt - 1,
              });
            }}
            handleIncrease={() => {
              onBookInf({
                childCnt: bookInf?.childCnt + 1,
              });
            }}
          />
        </div>
      </div>
      <div className="flex-1 col ">
        <h5>{t("bck_ttl_prmCd")}</h5>
        <PromCd />
      </div>
    </div>
  );
}
